
import { defineComponent, PropType } from 'vue';
import type { FlightLookupItem } from '@white-label-types/parking-checkout';
import TextField from '../text-field/text-field.vue';
import { IconMessage } from 'ui-shared-components';

export default defineComponent({
  name: 'FlightLookup',
  components: {
    TextField,
    IconButton: () => import('@white-label-icon/icon-button'),
    IconAlert: () => import('@white-label-icon/icon-alert'),
    IconCheck: () => import('@white-label-icon/icon-check'),
    IconAskMark: () => import('@white-label-icon/icon-ask-mark'),
    IconMessage,
  },

  props: {
    items: {
      type: Array as PropType<FlightLookupItem[]>,
      required: true,
    },
    value: {
      type: Object|null,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'inbound',
    },
    error: {
      type: Object|null,
      default: () => {},
    },
    errorLabel: {
      type: String,
    },
    inputType: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    flightChangeEnabled:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      searchQuery: '',
      filteredItems: [],
      dropdownOpened: false,
      isTooltipVisible: false,
      isEditing: false,
    };
  },
  computed: {
    prependIcon() {
      return () => import('@white-label-icon/icon-search');
    },

    localValue: {
      get(): FlightLookupItem|null {
        return this.value;
      },

      set(val: FlightLookupItem|null) {
        this.$emit('input', val);
      },
    },
    isInbound(): boolean {
      return this.direction === 'inbound';
    },
  },
  watch: {
    searchQuery() {
      this.filterItems();
    },
    items: {
      deep: true,
      handler() {
        this.filterItems();
      }
    },
  },
  created() {
    this.filterItems();
  },
  methods: {
    filterItems() {
      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.items.filter(item => {
        const airlineName = item.airlineName?.toLowerCase().includes(query);
        const terminal = item.terminalName ? item.terminalName.toLowerCase().includes(query) : false;
        const flightNumber = item.flightNumber?.toLowerCase().includes(query);
        const city = item.city?.toLowerCase().includes(query);
        const airport = item.airport?.toLowerCase().includes(query);

        return airlineName || terminal || flightNumber || city || airport;
      });
    },
    openDropdown() {
      this.dropdownOpened = true;
    },
    closeDropdown(): void {
      this.dropdownOpened = false;
    },
    selectItem(item: FlightLookupItem) {
      this.isEditing = false;
      this.localValue = item;
      this.closeDropdown();
    },
    clearSelection() {
      this.searchQuery = '';
      this.localValue = null;
    },
    editSelection() {
      this.isEditing = true;
      this.localValue = null;
      this.openDropdown();
    },
  },
});
